import { Component } from '@angular/core';
import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserInfo, UserService } from '../../services/user/user.service';


@Component({
    selector: 'app-admin-settings',
    styleUrls: ['admin-settings.component.css'],
    templateUrl: 'admin-settings.component.html',
})
export class AdminSettingsComponent {
    private _subrelease: Subject<void> = new Subject<void>();

    User: UserInfo | null;


    constructor(private userService: UserService) { 
        this.User = null;

        // Get the first non-null UserInfo object so we can begin setting up the component
        this.userService.UserSubject.pipe(
            takeUntil(this._subrelease),
            first(user => user && !!user.AuthToken)
        ).subscribe(user => {
            this.User = user;

            // Set up constant monitoring of the user object, to catch AuthToken updates.
            this.userService.UserSubject.pipe(takeUntil(this._subrelease)).subscribe(_user => {
                this.User = _user;
            });

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin-settings/admin-settings.component.ts